

export default function SideBar({children}) {
  return (
    <div className="sidebar">
      {children}
    </div>
  );
}


